document.addEventListener('DOMContentLoaded',function(){
  var root=document.querySelector('[data-band-config]');
  if(!root)return;
  var form=root.querySelector('form');
  var summary=root.querySelector('[data-order-summary]');
  var grid=summary&&summary.querySelector('[data-order-summary-grid]');
  if(!form||!summary||!grid)return;

  function valueOf(property){
    var field=form.querySelector('[name="properties['+property+']"]');
    if(!field||field.disabled)return '';
    if(field.type==='file')return field.files&&field.files[0]?field.files[0].name:'';
    if(field.tagName==='SELECT')return field.selectedOptions[0]?field.selectedOptions[0].textContent.trim():'';
    return String(field.value||'').trim();
  }

  function clean(value){return value.replace(/\s+[–-]\s+\d+[,.]\d{2}\s*€.*$/,'').trim()}

  function render(){
    var rows=[
      ['Text',valueOf('Text')],
      ['Bandart',valueOf('Bandart')],
      ['Bandfarbe',valueOf('Bandfarbe')],
      ['Schriftart',valueOf('Schriftart')],
      ['Wunschschrift',valueOf('Wunschschriftart')],
      ['Druckfarbe',valueOf('Druckfarbe')],
      ['Bandbreite',clean(valueOf('Bandbreite'))],
      ['Bandlänge',clean(valueOf('Bandlänge'))],
      ['Fertigung',valueOf('Fertigung')],
      ['Logo',valueOf('Logo')],
      ['Zweites Logo',valueOf('Logo 2')],
      ['Verschluss',valueOf('Farbe Armbandverschluss')]
    ].filter(function(row){return row[1]&&row[1]!=='Kein Logo'&&row[1]!=='Kein zweites Logo'});
    grid.replaceChildren();
    rows.forEach(function(row){
      var item=document.createElement('div');item.className='order-summary-item';
      var label=document.createElement('dt');label.textContent=row[0];
      var value=document.createElement('dd');value.textContent=row[1];value.title=row[1];
      item.append(label,value);grid.appendChild(item);
    });
    summary.hidden=!rows.length;
  }

  form.addEventListener('input',render);
  form.addEventListener('change',function(){render();requestAnimationFrame(render)});
  form.addEventListener('click',function(){requestAnimationFrame(render)});
  window.addEventListener('band:logos-rendered',render);
  render();
  setTimeout(render,100);
});
